import type UAParser from 'ua-parser-js';
import { DeviceType } from '../enums/deviceTypes.ts';

export const isDeviceMobile = (uaParser: UAParser.IResult) => uaParser.device.type === DeviceType.Mobile;
